module.exports = __webpack_public_path__ + "static/media/cross__white.aa28ccba.svg";